<template>
  <!-- <coming-soon /> -->
  <b-card no-body class="p-2 card-create information-card">
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-row>
          <b-col cols="12" class="mb-1">
            <b-skeleton width="12%" height="26px" />
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-skeleton width="6%" height="24px" />
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-skeleton width="70%" height="36px" />
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-skeleton width="60%" height="100px" />
          </b-col>
          <b-col cols="12" class="mb-1">
            <div class="d-flex flex-wrap">
              <b-skeleton width="10%" class=" mr-1" height="40px" />
              <b-skeleton width="10%" height="40px" />
            </div>
          </b-col>
          <b-col cols="12" class="mb-1">
            <div class="d-flex flex-wrap">
              <b-skeleton width="10%" class=" mr-1" height="40px" />
              <b-skeleton width="10%" height="40px" />
            </div>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col cols="12" md="6">
          <b-col cols="12">
            <toggle
              :fieldProperties="statusProperty"
              ref="statusToggle"
              @change.native="onToggleStatus"
            />
          </b-col>
          <b-col cols="12" class="mt-1">
            <label for="group-name" class="required">
              Group Name
            </label>
            <b-form-input
              id="group-name"
              placeholder="Group Name"
              required
              class="textbox-input"
              v-model="form.name"
            />
          </b-col>
          <b-col cols="12" class="mt-1">
            <label for="group-desription" class="required">
              Description
            </label>
            <b-form-textarea
              id="group-description"
              placeholder="Description..."
              required
              class="textbox-input"
              :max-rows="4"
              :rows="4"
              v-model="form.description"
            />
          </b-col>
          <b-col cols="12" class="mt-1">
            <label for="valid-from-date" class="required">
              Valid From
            </label>
            <div class="d-flex">
              <div class="p-relative mr-1 w-25">
                <calendar-picker-icon class="icon-calendar bypass" />
                <flat-pickr
                  :id="'valid-from-date'"
                  class="form-control  bg-date"
                  :config="flatpickrDateConfig"
                  placeholder="Start Date"
                  required
                  autocomplete="off"
                  v-model="form.validFrom.date"
                  @on-open="onOpenValidFromDatePicker"
                  @on-change="onSelectValidFromDate"
                />
              </div>
              <div class="p-relative w-25">
                <clock-picker-icon
                  class="icon-calendar date-picker-icon bypass"
                  :class="form.validFrom.time ? 'date-selected-icon' : null"
                />
                <flat-pickr
                  id="valid-from-time"
                  class="form-control  bg-date"
                  :class="form.validFrom.time ? 'date-selected' : null"
                  :config="flatpickrTimeConfig"
                  :placeholder="'HH : mm'"
                  required
                  autocomplete="off"
                  v-model="form.validFrom.time"
                  @on-open="onOpenValidFromTimePicker"
                  @on-change="onSelectValidFromTimePicker"
                />
              </div>
            </div>
          </b-col>
          <b-col cols="12" class="my-1">
            <label for="valid-from-to" class="required">
              Valid Through
            </label>
            <div class="d-flex">
              <div class="p-relative w-25 mr-1">
                <calendar-picker-icon
                  class="icon-calendar bypass"
                  :class="form.validThrough.date ? 'date-selected-icon' : null"
                />
                <flat-pickr
                  :id="'valid-to-date'"
                  class="form-control  bg-date"
                  :class="form.validThrough.date ? 'date-selected' : null"
                  :config="flatpickrDateConfig"
                  placeholder="End Date"
                  required
                  autocomplete="off"
                  v-model="form.validThrough.date"
                />
              </div>
              <div class="p-relative w-25">
                <clock-picker-icon
                  class="icon-calendar date-picker-icon bypass"
                  :class="form.validThrough.time ? 'date-selected-icon' : null"
                />
                <flat-pickr
                  id="valid-from-time"
                  class="form-control  bg-date"
                  :class="form.validThrough.time ? 'date-selected' : null"
                  :config="flatpickrTimeConfig"
                  :placeholder="'HH : mm'"
                  required
                  autocomplete="off"
                  v-model="form.validThrough.time"
                  @on-open="onOpenValidThroughTimePicker"
                />
              </div>
            </div>
          </b-col>
          <b-col cols="12" class="d-flex align-items-center">
            <span class="mr-1">{{ "Default: " }}</span>
            <b-form-checkbox
              switch
              class="banner-group-is-default-toggle"
              v-model="form.isDefault"
            />
          </b-col>
        </b-col>
      </b-row>
    </b-skeleton-wrapper>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BForm,
  BFormInput,
  BButton,
  BFormTextarea,
  BSkeletonWrapper,
  BSkeleton,
  BFormCheckbox,
} from "bootstrap-vue";
import ComingSoon from "@/views/components/coming-soon/ComingSoon.vue";
import Toggle from "@/views/components/dynamic-fields/components/ToggleFields.vue";
import flatPickr from "vue-flatpickr-component";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";

import useGroupBannerInformation from "../hooks/useGroupBannerInformation";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    ComingSoon,
    BForm,
    BFormInput,
    BButton,
    BFormTextarea,
    BSkeletonWrapper,
    BSkeleton,
    Toggle,
    ClockPickerIcon,
    CalendarPickerIcon,
    BFormCheckbox,
    flatPickr,
  },

  props: {
    groupBannerInformation: Object,
    loading: { type: Boolean, default: false },
  },

  setup(props) {
    const {
      statusProperty,
      form,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onSelectValidFromDate,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromTimePicker,
      onToggleStatus,
    } = useGroupBannerInformation(props);

    return {
      statusProperty,
      form,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onSelectValidFromDate,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromTimePicker,
      onToggleStatus,
    };
  },
};
</script>

<style></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
@import "~@/assets/css/pages/banner/banner-table.css";
@import "~@/assets/css/pages/banner/create-banner.css";
@import "~@/assets/css/pages/banner/create-set-banner.css";
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>
